import type { OrderOptions } from '@/shared/lib';

export const DOCUMENT_ALREADY_LINKED_TO_FOLDER_CODE = 'DOCUMENT_ALREADY_LINKED_TO_FOLDER';

export const ADD_DOCUMENT_MODAL_COPY = {
  title: 'Adicionar Documento',
  tableTitle: 'Selecione os Documentos que deseja adicionar',
  confirmButtonText: 'Adicionar',
  fallbackSearchUrl: '/documents/search',
} as const;

export const ADD_DOCUMENT_DEFAULT_AMOUNT = 10;

/**
 * Maximum documents per link, mirroring `@ArrayMaxSize(200)` on the
 * `LinkDocumentsToDirectoryDTO`. Without the cap in the modal, "select all" with "all documents"
 * goes past 200 and the backend rejects the whole batch with a 400.
 */
export const ADD_DOCUMENT_MAX_SELECTIONS = 200;

export const ADD_DOCUMENT_SELECTION_LIMIT_MESSAGE = `O número máximo de documentos selecionados é ${ADD_DOCUMENT_MAX_SELECTIONS}.`;

/**
 * Sort option accepted by the eligible-documents endpoint.
 *
 * The endpoint rejects any other sort field with HTTP 400, so the narrowed field and
 * direction turn an unsupported option into a compile error instead of a runtime failure.
 */
interface EligibleDocumentsOrderOption extends OrderOptions {
  sort: 'effectiveDate' | 'name';
  order: 'asc' | 'desc';
}

/**
 * Sort options exposed by the "Adicionar Documento" modal.
 *
 * They are a subset of the shared options, so this flow never offers an order the
 * eligible-documents endpoint cannot serve.
 */
export const ADD_DOCUMENT_ORDER_OPTIONS: EligibleDocumentsOrderOption[] = [
  { label: 'Arquivo mais recente', sort: 'effectiveDate', order: 'desc' },
  { label: 'Arquivo mais antigo', sort: 'effectiveDate', order: 'asc' },
  { label: 'Ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Ordem alfabética decrescente', sort: 'name', order: 'desc' },
];
